import React from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";

import { FormatAmount } from "../../../utils/Formatter";
import "./PaymentInfo.css";
import TestIndicator from "../../common/TestIndicator";

const useStyles = makeStyles(({ palette }) => {
  return {
    root: {
      color: palette.primary.contrastText,
      background: `linear-gradient(36deg, ${palette.primary.dark} 0%, ${palette.primary.main} 54%, ${palette.primary.light} 100%)`,
      padding: "25px",
      alignItems: "center",
      display: "flex",
      position: "relative",
      fontSize: "1.15rem"
    }
  };
});

const getLogo = charge => {
  const { theme } = charge;
  return theme ? theme.logo : "default";
};

const PaymentInfo = ({ charge }) => {
  const classes = useStyles();
  const amount = FormatAmount(charge.amount, charge.currency);
  return (
    <div className={classes.root}>
      <div className="shop-logo-container">
        <img src={`/static/shop-logo/${getLogo(charge)}`} alt="Logo" />
      </div>
      <div style={{ minWidth: "200px" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div id="shopName">{charge.shopName}</div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div id="orderId">{`#${charge.orderId}`}</div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div id="amount">{amount}</div>
        </div>
        {charge.testMode && <TestIndicator />}
      </div>
    </div>
  );
};

PaymentInfo.propTypes = {
  charge: PropTypes.shape({
    currency: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    shopId: PropTypes.string.isRequired,
    shopName: PropTypes.string.isRequired,
    shopLogoId: PropTypes.string,
    orderId: PropTypes.string.isRequired,
    testMode: PropTypes.bool.isRequired
  }).isRequired
};

export default PaymentInfo;
